export const ACTIVATE_USER = 'ACTIVATE_USER';
export const ACTIVATE_USER_DONE = 'ACTIVATE_USER_DONE';
export const ACTIVATE_USER_ERR = 'ACTIVATE_USER_ERR';
export const RESET_USER_ACTIVATION = 'RESET_USER_ACTIVATION';
//# sourceMappingURL=actionTypes.js.map